angular
    .module('empower.contactUs')
    .controller('contactUsController', ['$scope', '$rootScope', '$filter', '$timeout', 'contactUsService', 'popupService', '$window', 'commonConst', 'feedbackEnquiryConst', 'jurisdictionEnum', 'dropdownToShowEnum', 'feedbackWording', 'jurisdictionEnum', 'uploadDocumentService', 'uploadFileWording', 'httpService',
        function ($scope, $rootScope, $filter, $timeout, contactUsService, popupService, $window, commonConst, contactUsEnquiryConst, jurisdictionEnum, dropdownToShowEnum, contactUsWording, jurisdictionEnum, uploadDocumentService, uploadFileWording, httpService) {
            var maxNumberOfFiles = 5;
            UploadFileExtension($scope, {
                // $form: document.querySelector('#fileupload'),
                submitText: 'Uploading ...',
                fnSubmitFile: fnSubmitFile,
                fnFileUploadStop: fnFileUploadStop,
                fnFormValidation: fnFormValidation,
                maxNumberOfFiles: maxNumberOfFiles
            }, uploadFileWording, $window, httpService);
            $scope.pageBreadcrumbs = [{
                url: '/',
                title: 'Home'
            }, {
                url: null,
                title: 'Contact us'
            }];
            $scope.formData = {
                policyId: null,
                claimId: null,
                message: '',
                employerName: '',
                uploadSession: $scope.generateUploadSession()
            }
            $scope.textLimit = 500;
            $scope.selectedData = {
                policy: null,
                claim: null
            };
            $scope.baseUploadPath = 'uploads';
            $scope.jurisdictionEnum = jurisdictionEnum;
            $scope.isNsiEmployer = $rootScope.user.IsNsiUser && !$rootScope.user.IsClaimant;

            if (!$rootScope.user.IsClaimant) {
                $scope.$on('policySelectionChanged', function (event, policy) {
                    if (!policy ||
                        (!!$scope.selectedData.claim &&
                            $scope.selectedData.claim.PolicyId !== policy.EmployerId)) {
                        $scope.$broadcast('resetClaimSelection');
                    }
                });
            }

            $scope.$on('claimSelectionChanged', function (event, claim) {
                if (!!claim && claim.ClaimId) {
                    $scope.$broadcast('setPolicySelection', new PolicyModel(claim));
                }
            });

            $scope.enquiry = [];
            $scope.selectedJurisdiction = $rootScope.getSelectedJurisdiction();
            $scope.init = function () {
                $rootScope.pageName = "Contact Us";

                if ($rootScope.user.IsClaimant) {
                    $scope.enquiry = contactUsEnquiryConst.WORKER;

                } else {
                    if ($rootScope.user.IsNsiUser) {
                        $scope.enquiry = contactUsEnquiryConst.NSI_WORKER;
                    } else {
                        var nationalOrVicSelected = $scope.selectedJurisdiction === jurisdictionEnum.ALL ||
                            $scope.selectedJurisdiction === jurisdictionEnum.VIC;
                        var recentlySelectedType = $filter('decstr64')(sessionStorage.RecentlySelectedType);

                        $scope.enquiry = nationalOrVicSelected ? contactUsEnquiryConst.VIC_EMPLOYER : contactUsEnquiryConst.NSW_EMPLOYER;

                        if (recentlySelectedType === commonConst.CLAIM &&
                            nationalOrVicSelected) {
                            $scope.enquiryValue = $scope.enquiry[1].id.toString();
                            return;
                        }
                    }
                }

                $scope.enquiryValue = $scope.enquiry[0].id.toString();
            }

            $scope.isClaimRequired = function () {
                if ($rootScope.user.IsClaimant) {
                    return true;
                } else {
                    return $scope.enquiryValue === '1' || $scope.user.IsNsiUser;
                }
            }

            $scope.sendEmail = function () {
                $timeout(function () {
                    angular.element(document.activeElement).blur();
                });

                if ($scope.fileData && $scope.fileData.scope.queue.length > 0) {
                    $scope.submitFile(this);
                } else {
                    $scope.sendFeedback();
                }
            }

            $scope.allowedJurisdiction = function () {
                if ($scope.enquiryValue === '0' || $scope.enquiryValue === '2') {
                    // allow VIC only
                    return [2]
                } else {
                    // allow all
                    return null;
                }
            }
            $scope.aClicked = false;
            $scope.selectFiles = function (f) {
                $timeout(function () {
                    if (!$scope.aClicked) {
                        angular.element(f).trigger('click');
                    }
                    $scope.aClicked = false;
                }, 100);

            } // selectFiles
            $('body').on('click', '.upload-file', function () {
                $scope.aClicked = true;
            })
            $scope.sendFeedback = function () {
                contactUsService.sendFeedback({
                    Message: $scope.formData.message,
                    PolicyId: $scope.formData.policyId,
                    ClaimId: $scope.formData.claimId,
                    EnquiryType: $scope.enquiryValue,
                    BusinessUnit: $scope.selectedJurisdiction,
                    UploadSession: $scope.formData.uploadSession,

                }).then(function (data) { // this is only run after $http completes
                    if (!!$scope.formData.claimId) {
                        sessionStorage.RecentlySelectedType = $filter('enstr64')(commonConst.CLAIM);
                        sessionStorage.Claim = $filter('enstr64')(JSON.stringify($scope.selectedData.claim));

                    } else if (!!$scope.formData.policyId) {
                        sessionStorage.RecentlySelectedType = $filter('enstr64')(commonConst.POLICY);
                        sessionStorage.Policy = $filter('enstr64')(JSON.stringify($scope.selectedData.policy));
                    }

                    popupService.showText(contactUsWording.SEND_FEEDBACK_SUCCESS, undefined, function () {
                        //Redirect user to homepage
                        $window.location = "/";
                    });
                }, function (error) { // run if fail request
                    popupService.showError(contactUsWording.SEND_FEEDBACK_FAILED, undefined, function () {
                        //Redirect user to homepage
                        $window.location = "/";
                    });
                });
            }

            $scope.removeFile = function (file, queue) {
                event.stopPropagation();
                event.preventDefault();
                file.$cancel();
                if (queue.length == 0) {
                    $scope.clearError();
                    $scope.uploadControl.allowSubmit = false;
                }
            } // removeFile

            $scope.getEnquiryValue = function (enquiryValue) {
                $scope.enquiryValue = enquiryValue;
            }
            $scope.getMessageNumber = function () {
                $scope.textLimit = 500 - $("#contact-us-message").val().length
            }

            function fnSubmitFile() {
                $scope.uploadResult.hasError = false;
                $scope.uploadControl.isProcessing = true;
                $scope.uploadControl.allowAddFile = false;
                $scope.uploadControl.allowSubmit = false;
                $scope.uploadControl.submitText = 'Uploading...';
            } // fnSubmitFile

            function fnFileUploadStop(e) {
                if ($scope.uploadResult.hasError) {
                    var uploadError = $scope.getFileUploadError();
                    //popupService.showValidationServerErrors(uploadError, undefined, reload);

                } else {
                    $scope.sendFeedback();
                }
            }; // fnFileUploadStop

            function fnFormValidation() {
                if ($scope.enquiryValue === '1' &&
                    !$scope.formData.claimId) {
                    popupService.showText(contactUsWording.REQUIRED_CLAIM);
                    return false;
                }

                if ($scope.enquiryValue !== '1' && !$rootScope.user.IsClaimant &&
                    (!$rootScope.user.IsNsiUser && !$scope.formData.policyId)) {
                    popupService.showText(contactUsWording.REQUIRED_POLICY);
                    return false;
                }
                if ($scope.formData.message.length > 500) {
                    popupService.showText(contactUsWording.MESSAGE_TOO_LONG);
                    return false;
                }

                return true;
            } // validateFormData


        }
    ]);